import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Header } from '../components/Header';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
import { Award, Users, TrendingUp, HeartHandshake } from 'lucide-react';
export function WhyROIPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const reasons = [{
    icon: Award,
    title: 'Built by Operators',
    description: "We're not just software engineers. We've managed kitchens, run front-of-house, and balanced restaurant books for decades."
  }, {
    icon: Users,
    title: 'Unmatched Support',
    description: "Our support team speaks your language. We're available when you are—including late nights and weekends."
  }, {
    icon: TrendingUp,
    title: 'Proven ROI',
    description: 'Our clients see an average of 3-5% increase in net profit margins within the first 90 days of implementation.'
  }, {
    icon: HeartHandshake,
    title: 'No Hidden Fees',
    description: 'Transparent pricing with no implementation fees, no per-user charges, and no long-term lock-in contracts.'
  }];
  return <main className="min-h-screen bg-stark-white" data-id="element-241">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-242" />

      <section className="pt-32 pb-20 bg-midnight-navy text-stark-white" data-id="element-243">
        <div className="max-w-7xl mx-auto px-6" data-id="element-244">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="max-w-3xl" data-id="element-245">
            <h1 className="text-5xl md:text-6xl font-manrope font-bold mb-6" data-id="element-246">
              Why ROI?
            </h1>
            <p className="text-xl text-stark-white/70 leading-relaxed" data-id="element-247">
              In an industry where every penny counts, you need a partner that
              understands the stakes.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24" data-id="element-248">
        <div className="max-w-7xl mx-auto px-6" data-id="element-249">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-250">
            {reasons.map((reason, idx) => <motion.div key={reason.title} initial={{
            opacity: 0,
            x: idx % 2 === 0 ? -20 : 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="flex gap-6" data-id="element-251">
                <div className="shrink-0 w-16 h-16 bg-midnight-navy text-stark-white rounded-xl flex items-center justify-center" data-id="element-252">
                  <reason.icon className="w-8 h-8" data-id="element-253" />
                </div>
                <div className="space-y-3" data-id="element-254">
                  <h3 className="text-2xl font-manrope font-bold text-midnight-navy" data-id="element-255">
                    {reason.title}
                  </h3>
                  <p className="text-lg text-midnight-navy/60 leading-relaxed" data-id="element-256">
                    {reason.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      <section className="py-24 bg-cool-gray" data-id="element-257">
        <div className="max-w-7xl mx-auto px-6 text-center space-y-12" data-id="element-258">
          <h2 className="text-4xl font-manrope font-bold text-midnight-navy" data-id="element-259">
            Trusted by the Best
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-12 opacity-40 grayscale" data-id="element-260">
            {/* Placeholder for logos */}
            <div className="h-12 bg-midnight-navy/20 rounded-md" data-id="element-261" />
            <div className="h-12 bg-midnight-navy/20 rounded-md" data-id="element-262" />
            <div className="h-12 bg-midnight-navy/20 rounded-md" data-id="element-263" />
            <div className="h-12 bg-midnight-navy/20 rounded-md" data-id="element-264" />
          </div>
        </div>
      </section>

      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-265" />
      <Footer data-id="element-266" />
      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-267" />
    </main>;
}